import { AnnotationScope } from "~/components/build/Show/lib/types/Annotation";

/**
 * Action Cable events from Pipelines::BuildChannel that should trigger a build refetch.
 */
export enum BuildChannelEvent {
  Updated = "updated",
  Started = "started",
  Finished = "finished",
  Failing = "failing",
  Skipped = "skipped",
  Canceling = "canceling",
  CommitChanged = "commit:changed",
  StepsChanged = "steps:changed",
  PipelineChanged = "pipeline:changed",
  AnnotationsChanged = "annotations:changed",
}

type StepsChangedMessage = { event: BuildChannelEvent.StepsChanged; step_uuids: string[] };

type PipelineChangedMessage = {
  event: BuildChannelEvent.PipelineChanged;
  step_added_uuids: string[];
  step_changed_uuids: string[];
  step_destroyed_uuids: string[];
};

type AnnotationsChangedMessage = {
  event: BuildChannelEvent.AnnotationsChanged;
  scope: AnnotationScope;
  job_uuid?: string;
};

export type BuildChannelMessage =
  | {
      event: Exclude<
        BuildChannelEvent,
        | BuildChannelEvent.StepsChanged
        | BuildChannelEvent.PipelineChanged
        | BuildChannelEvent.AnnotationsChanged
      >;
    }
  | PipelineChangedMessage
  | StepsChangedMessage
  | AnnotationsChangedMessage;
